import { render, staticRenderFns } from "./VideoEmbeds.vue?vue&type=template&id=0eaeb36d&scoped=true"
import script from "./VideoEmbeds.vue?vue&type=script&lang=js"
export * from "./VideoEmbeds.vue?vue&type=script&lang=js"
import style0 from "./VideoEmbeds.vue?vue&type=style&index=0&id=0eaeb36d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaeb36d",
  null
  
)

export default component.exports